import React from "react";

// "OnHuman.tech" wordmark — mirrors the HR wordmark structure for brand
// consistency, but in white with a cyan→violet ".tech" suffix that signals
// the technology division.
export default function OnHumanTechLogo({
  className = "h-10 w-auto",
  title = "OnHuman.tech",
}) {
  return (
    <svg
      viewBox="0 0 340 80"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="ohtech-suffix" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#22d3ee" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
        <filter id="ohtech-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow
            dx="0"
            dy="1"
            stdDeviation="1.2"
            floodColor="#000000"
            floodOpacity="0.55"
          />
        </filter>
      </defs>

      {/* OnHuman — matches HR weight/style, in white */}
      <text
        x="10"
        y="56"
        fontFamily="'Inter','Segoe UI',system-ui,-apple-system,sans-serif"
        fontSize="52"
        fontWeight="900"
        letterSpacing="-1.6"
        fill="#ffffff"
        filter="url(#ohtech-shadow)"
      >
        OnHuman
      </text>

      {/* .tech suffix — gradient mono, smaller, sits on the same baseline */}
      <text
        x="232"
        y="56"
        fontFamily="'JetBrains Mono','Menlo','Consolas',monospace"
        fontSize="30"
        fontWeight="700"
        letterSpacing="-0.5"
        fill="url(#ohtech-suffix)"
        filter="url(#ohtech-shadow)"
      >
        .tech
      </text>
    </svg>
  );
}
